import { IFormInputOption } from "@components/form/interfaces/form-interface";

export interface IAspectRatioData {
  id: string;
  value: string;
  text: string;
}

export const aspectRatioData: IFormInputOption[] = [
  { value: '16:9', label: '16:9' },
  { value: '3:2', label: '3:2' },
  { value: '3:4', label: '3:4' },
  { value: '2:1', label: '2:1' },
]